angular.module('v3sWbtPlayerApp').directive('v3sMobileViewOpener', ["$rootScope", "$window", "$document", "$interval", "v3sI18nService", function ($rootScope, $window, $document, $interval, v3sI18nService) {
    return {
        restrict: 'E',
        scope: {
            v3sUrl: '@',
            v3sCancel: '&'
        },
        templateUrl: "app/js/wbt/opener/opener.tpl.html",
        link: function (scope, element, attrs) {

            var wbtOpened = null;
            var language = navigator.language || navigator.userLanguage;
            v3sI18nService.setLanguage(language);

            scope.wbtWithoutFrames = null;
            scope.hideButtons = false;
            scope.title = "general.mobileViewWithoutFrame.title.open";
            scope.message = "general.mobileViewWithoutFrame.message.open";

            var updateMessage = function (wbtOpened) {
                scope.$evalAsync(function () {
                    scope.hideButtons = true;

                    if (wbtOpened) {
                        scope.title = "general.mobileViewWithoutFrame.title.processing";
                        scope.message = "general.mobileViewWithoutFrame.message.processing";
                    } else {
                        scope.title = "general.mobileViewWithoutFrame.title.close";
                        scope.message = "general.mobileViewWithoutFrame.message.close";
                    }
                });   
            };

            var checkProgress = function () {
                if (!!scope.wbtWithoutFrames.closed) {
                    updateMessage(false);
                    scope.wbtWithoutFrames = null;
                    $interval.cancel(wbtOpened);
                }
            };

            var openInNewWindow = function () {
                if (!scope.wbtWithoutFrames && !!scope.v3sUrl) {
                    scope.wbtWithoutFrames = window.open(scope.v3sUrl, "_blank");
                    updateMessage(true);
                    wbtOpened = $interval(checkProgress, 500);
                }
            };

            var openInCurrentWindow = function () {
                scope.v3sCancel()();
            };

            angular.element(document.getElementById("yes")).bind('click', openInNewWindow);
            angular.element(document.getElementById("no")).bind('click', openInCurrentWindow);

            //Neues Fenster bei Änderung des Frame-URLs aktualisieren
            scope.$watch('v3sUrl', function (newAnswer, oldAnswer) {
                if (newAnswer !== oldAnswer) {
                    if (!!scope.wbtWithoutFrames) {
                        scope.wbtWithoutFrames.location.replace(newAnswer);
                        updateMessage(true);
                    }
                }
            });
        }
    }
}]);